import type { NavigateFunction } from 'react-router-dom';

import { doc, getDoc } from 'firebase/firestore';

import { screenType } from '../../../constants/enum';
import { usersRef } from '../../firebase/firestore/user/index';

import type { User } from 'firebase/auth';

export const navigateMypage = async (
  user: User,
  navigate: NavigateFunction
): Promise<void> => {
  const userRef = doc(usersRef, user.uid);
  const userSnap = await getDoc(userRef);
  if (userSnap.exists()) {
    const registerStatus: number = userSnap.data().registerStatus as number;
    const type: number = userSnap.data().type as number;

    if (type === screenType.client) {
      if (registerStatus === 1) {
        navigate('/client/mypage');
      } else if (registerStatus === 2) {
        navigate(
          `/client/auth/basic?email=${
            userSnap.data().email as string
          }&anchor=login`
        );
      } else if (registerStatus === 3) {
        navigate('/client/auth/company');
      }
    } else if (type === screenType.agent) {
      if (registerStatus === 1) {
        navigate('/agent/mypage');
      } else if (registerStatus === 2) {
        navigate(
          `/agent/auth/basic?email=${
            userSnap.data().email as string
          }&anchor=login`
        );
      } else if (registerStatus === 3) {
        navigate('/agent/auth/company');
      }
    } else if (registerStatus === 1) {
      navigate('/publisher/mypage');
    } else {
      navigate(
        `/publisher/auth/basic?email=${
          userSnap.data().email as string
        }&anchor=login`
      );
    }
  } else {
    throw new Error();
  }
};
